import React from 'react';
import { Dumbbell } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface FooterProps {
  onNavigate: (page: 'home' | 'privacy' | 'terms') => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const {
    t
  } = useLanguage();
  return <footer className="bg-brand-dark border-t border-white/10 py-12 px-4" data-id="element-87">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-88">
        <button onClick={() => onNavigate('home')} className="flex items-center gap-2 group" data-id="element-89">
          <Dumbbell className="w-6 h-6 text-brand-accent group-hover:rotate-12 transition-transform duration-300" data-id="element-90" />
          <span className="font-display text-xl tracking-wider text-white" data-id="element-91">
            COACH<span className="text-brand-accent" data-id="element-92">ALEX</span>
          </span>
        </button>

        <div className="text-gray-500 text-sm" data-id="element-93">
          © {new Date().getFullYear()} {t.footer.copyright}
        </div>

        <div className="flex gap-6" data-id="element-94">
          <button onClick={() => onNavigate('privacy')} className="text-gray-500 hover:text-brand-accent text-sm transition-colors" data-id="element-95">
            {t.footer.privacy}
          </button>
          <button onClick={() => onNavigate('terms')} className="text-gray-500 hover:text-brand-accent text-sm transition-colors" data-id="element-96">
            {t.footer.terms}
          </button>
        </div>
      </div>
    </footer>;
}